import React, { forwardRef } from 'react'

/**
 * Scroll region for wide tables + bounded height (or flex fill).
 * Styled scrollbars via .scrollable-table-shell-host in index.css.
 *
 * @param {boolean} [forceHorizontalScroll] - If true, horizontal scrollbar track stays visible when content overflows (overflow-x: scroll).
 * @param {boolean} [fillParent] - If true, use flex:1/minHeight:0 instead of maxHeight so one parent column owns vertical scroll.
 */
const ScrollableTableShell = forwardRef(function ScrollableTableShell(
  {
    children,
    minTableWidth = '1100px',
    maxHeight = 'calc(100vh - 280px)',
    forceHorizontalScroll = false,
    fillParent = false,
  },
  ref
) {
  const sizeStyle = fillParent
    ? { flex: 1, minHeight: 0, minWidth: 0, maxHeight: 'none' }
    : { maxHeight }

  return (
    <div
      ref={ref}
      className="scrollable-table-shell-host"
      style={{
        overflowY: 'auto',
        overflowX: forceHorizontalScroll ? 'scroll' : 'auto',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        ...sizeStyle,
      }}
    >
      <div style={{ minWidth: minTableWidth, width: '100%', boxSizing: 'border-box' }}>
        {children}
      </div>
    </div>
  )
})

ScrollableTableShell.displayName = 'ScrollableTableShell'

export default ScrollableTableShell
